import React, { useState, useEffect, useContext } from 'react'
import DatePicker from "react-datepicker";
import moment from "moment";
import "./calendarIntegration.css";

import 'react-big-calendar/lib/css/react-big-calendar.css';
import { DELETE, GET, POST, PUT } from "../../../Common/HttpMethods/HttpMethods";
import { Url } from '../../../../constants/ApiUrlConstants';

import { FaAngleRight, FaAngleLeft, FaArrowRight } from "react-icons/fa6";
import { IoPersonCircleOutline } from "react-icons/io5"
import Modal from "react-modal";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { BsDownload, BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { AiOutlineClose, AiOutlineDelete } from "react-icons/ai";
import { contextData } from '../../../../context/ContextProvider'
import { useNavigate } from 'react-router-dom';
import FailModal from '../../../Common/Popups/FailModal';
import SuccessModal from '../../../Common/Popups/SuccessModal';
import CancelReason from '../../../Common/Popups/CancelReason';
import { IoCaretForward } from "react-icons/io5";
import { IoCaretBack } from "react-icons/io5";
import { red } from '@mui/material/colors';
import DOMPurify from 'dompurify';
import Select from "react-select";
import { MdSchedule } from 'react-icons/md';
import { CanceledBy, Cuurent_EMAIL, Cuurent_RBAC_roles, Cuurent_USERNAME, Cuurent_USER_ROLES, GeneratePDF, extractMeetingData, extractTextFromHtml, firstLineTextFromHtml, getAllToFromOptionalEmailArr, getEmailClassification, stripHtmlTags, useRBAC } from '../../../CommonCase/CommonFunctions';
import UpcomingMeetingModal from '../../../CommonCase/UpcomingMeetingModal';
import CancelledMeetingModal from '../../../CommonCase/CancelledMeetingModal';
import { FileDownload } from '../../../Common/IcsDownload/FileDownload';

export const goToSetupMeeting = (access, navigate, setActive) => {

  let isOrganizer = access?.includes("QMS Organizer");

  if (isOrganizer) {
    navigate("/main/meetings/setupmeeting");
    setActive('tab2')
  }
}

export const isTimeBefore2AM = (timeString) => {
  // Create a Date object with the input time string
  const inputTime = new Date(`2000-01-01 ${timeString}`);

  // Create a Date object for 2:00 AM (corrected the time comparison to 2:00 AM)
  const twoAM = new Date('2000-01-01 02:00 AM');

  // Compare the two times
  return inputTime < twoAM;
};

export const mouseEnter = (event, setPos) => {
  const rect = event?.target?.getBoundingClientRect();
  if (rect) {
    let x = rect.left;
    let y = rect.top;
    if (x < 800) {
      setPos(false);
    } else {
      setPos(true);
    }
  } 
};

export const downloadIcs = async (id, name) => {
  FileDownload(id, name);
};

export const handleEdit = (id, navigate) => {
  navigate("/main/meetings/setupmeeting", {
    state: { meetingId: id, flow: "CancelledMeetings", cancelledMeetingEdit: true }
  });
};

export const handleCloseFullView = (setFullView) => {
  setFullView((prevState) => ({
    isClicked: false,
    viewMoreAttendees: false,
    typeOfMeeting: null,
    data: {}
  }));
}
export const navigateToMeeting = (metingData, setViewPastMeeting, setFromPastMeeting, navigate, AccRoles) => {
  if (metingData?.typeOfMeeting == "Past" && metingData?.hasMOM == "view") {
    setViewPastMeeting({ isView: true, meetingId: metingData?.mid })
    setFromPastMeeting('cal')
    navigate("/main/meetings/my-meetings")
  }
  else if ((AccRoles.includes("QMS Organizer")) && (metingData?.typeOfMeeting == "Past" && metingData?.hasMOM == "N/A")) {
    navigate("/main/meetings/edit-past-meeting", { state: { meetingId: metingData?.mid } });
  }
}

export const handleNavigateForEditMeeting = (event, navigate) => {
  switch (event.typeOfMeeting) {
    case "Past":
      navigate("/main/meetings/edit-past-meeting", { state: { meetingId: event?.mid } });
      break;
    case "Upcoming":
    case "Cancelled":
    case "Ongoing":
      navigate("/main/meetings/setupmeeting", { state: { meetingId: event?.mid, flow: "UpcomingMeetings", upcomingMeetingEdit: true } })
      break;
  }
}

export const customTimeFormat = (date) => {
  return moment(date).format('ha').toUpperCase(); // Display as 12AM, 1AM, etc.
};

export const handleSetDatePickerDate = (date, setDatePickerDate) => {
  setDatePickerDate(date);
}

export const handleSessionExpClose = (navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const setCurrentView = (view, setView) => {
  setView(view)
}

export const CustomWeekHeader = ({ date }) => {
  const formattedDate = moment(date).format('D');
  const formattedDay = moment(date).format('dddd').toLocaleUpperCase();

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '13px', fontWeight: 600, textAlign: 'left' }}>{formattedDay}</div>
      <div className='custom-day-in-week-view border-class' style={{ fontSize: '13px', lineHeight: 0.6, fontWeight: 600, textAlign: 'left' }}>{formattedDate}</div>
    </div>
  );
};

const CustomMonthHeader = ({ date }) => {
  const formattedDay = moment(date).format('dddd').toLocaleUpperCase();

  return (
    <div className='custom-day-in-day-view' style={{ textAlign: 'center', fontSize: '14px', fontWeight: 500, marginLeft: 5 }}>{formattedDay}</div>
  );
};

export const CustomHeaderDay = ({ date, label }) => {
  const formattedDate = moment(date).format('D');
  const formattedDay = moment(date).format('dddd').toLocaleUpperCase();

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '13px', fontWeight: 600, textAlign: 'left' }}>{formattedDay}</div>
      <div className='custom-day-in-week-view border-class' style={{ fontSize: '13px', lineHeight: 0.6, fontWeight: 600, textAlign: 'left' }}>{formattedDate}</div>
    </div>
  );
}

export const isOverflowingCalInt = (element) => {
  return element?.scrollHeight > element?.clientHeight || element?.scrollWidth > element?.clientWidth;
}

export const moveToPrevMonth = (view, datePickerDate, setDatePickerDate) => {
  if (view == "week") {
    const previousSevenDays = moment(datePickerDate).subtract(7, 'days');
    const formattedDate = previousSevenDays.format('YYYY-MM-DD')

    setDatePickerDate(new Date(formattedDate));
  }
  else if (view == "month") {
    const newDate = new Date(datePickerDate);
    newDate.setDate(1)
    newDate.setMonth(newDate.getMonth() - 1);
    setDatePickerDate(newDate);
  }
  else if (view == "day") {
    const previousDay = moment(datePickerDate).subtract(1, 'days');
    const formattedDate = previousDay.format('YYYY-MM-DD')

    setDatePickerDate(new Date(formattedDate));
  }
};

export const handleCloseDeleteModel = (setOpenDeleteModal) => {
  setOpenDeleteModal(false);
};

export const handleCloseCancleModal = (setOpenCancelModal) => {
  setOpenCancelModal(false);
};

export const reasonChange = (e, setReason) => {
  setReason(e.target.value);
};

export const handleONRequestUPMFV = (setUpcomingFVModal, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight) => {
  setUpcomingFVModal(false);
  setAgendaDivHeight(false);
  setMsgDivHeight(false);
  setAttendeesDivHeight(false);
};

export const handle_Close_Cancel_Modal = (setCIcancelMeetOpenView, setAgendaDivHeight, setMsgDivHeight) => {
  setCIcancelMeetOpenView(false);
  setAgendaDivHeight(false);
  setMsgDivHeight(false);
};

export const moveToNextMonth = ({ view, datePickerDate, setDatePickerDate }) => {
  if (view === "week") {
    const nextSevenDays = moment(datePickerDate).add(7, 'days');
    const formattedDate = nextSevenDays.format('YYYY-MM-DD');
    setDatePickerDate(new Date(formattedDate));
  }
  else if (view === "month") {
    const newDate = new Date(datePickerDate);
    newDate.setDate(1);  // Set to the first day of the current month
    newDate.setMonth(newDate.getMonth() + 1);  // Move to next month
    setDatePickerDate(newDate);
  }
  else if (view === "day") {
    const nextDay = moment(datePickerDate).add(1, 'days');
    const formattedDate = nextDay.format('YYYY-MM-DD');
    setDatePickerDate(new Date(formattedDate));
  }
};


export const getCalendarDataByView = async ({
  POST,
  Url,
  token,
  monthStartDate,
  monthEndDate,
  setLoading,
  setEventData,
  setFailMessage,
}) => {
  setLoading(true);

  try {
    // Make the API request
    const calendarMeetingResp = await POST(Url.getMeetingsByCalendarType, token, {
      startDate: monthStartDate,
      endDate: monthEndDate,
      calendarType: "month",
    });

    if (calendarMeetingResp.SUCCESS) {
      const eventToSet = [];

      // Process the response to extract event data
      calendarMeetingResp?.DATA?.forEach((outer) => {
        outer?.calendarIntegrationDTO?.forEach((inner) => {
          const startTime24 = moment(inner.startTime, 'hh:mm A').format('HH:mm');
          const endTime24 = moment(inner.endTime, 'hh:mm A').format('HH:mm');

          const event = {
            ...inner,
            calendarIntegrationDTO: outer?.calendarIntegrationDTO,
            startTime24,
            endTime24,
            count: outer.calendarIntegrationDTO?.length,
            start: new Date(inner?.startDate[0], inner?.startDate[1] - 1, inner?.startDate[2], parseInt(startTime24?.split(":")[0]), parseInt(startTime24?.split(":")[1])),
            end: new Date(inner?.startDate[0], inner?.startDate[1] - 1, inner?.startDate[2], parseInt(endTime24?.split(":")[0]), parseInt(endTime24?.split(":")[1])),
          };

          eventToSet.push(event);
        });
      });

      setEventData(eventToSet);
      setLoading(false);
    } else if (calendarMeetingResp.STATUS === 401) {
      setLoading(false);
      setFailMessage("Session expired");
    } else if (calendarMeetingResp.STATUS === 400) {
      setLoading(false);
      setFailMessage("Session expired");
    }else if (calendarMeetingResp.STATUS === 403) {
      setLoading(false);
      setFailMessage("Session expired");
    }else if (calendarMeetingResp.STATUS === 404) {
      setLoading(false);
      setFailMessage("Session expired");
    }else if (calendarMeetingResp.STATUS === 500) {
      setLoading(false);
      setFailMessage("Session expired");
    }else {
      setLoading(false);
      setFailMessage("Failed to fetch calendar data.");
    }
  } catch (err) {
    setLoading(false);
    setFailMessage("Error occurred while fetching calendar data.");
  }
};


export function generateHighlightedDates(date, type, setHighlightedDatesToShow) {
  const highlightedDates = [];

  if (type === 'month') {
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate(); // Number of days in the month

    for (let i = 1; i <= daysInMonth; i++) {
      highlightedDates.push(new Date(year, month, i));
    }
  } else if (type === 'week') {
    const currentDate = new Date(date); // Copy the given date
    const dayOfWeek = currentDate.getDay(); // Day of the week (0-6, 0 is Sunday)
    const startOfWeek = new Date(currentDate); // Start of the week (Sunday)
    startOfWeek.setDate(currentDate.getDate() - dayOfWeek); // Adjust to Sunday

    for (let i = 0; i < 7; i++) {
      highlightedDates.push(new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + i));
    }
  } else if (type === 'day') {
    highlightedDates.push(date); // For a single day, just return the date
  }else{
    highlightedDates.push(date);
  }

  // Set the highlighted dates in the state
  setHighlightedDatesToShow(highlightedDates);
}

export const handleOpenFullView = async ({
  meetData,
  GET,
  Url,
  token,
  setLoading,
  setUpcomingFVModal,
  setCIcancelMeetOpenView,
  setFullView,
  extractMeetingData,
  setSessionExpiredModal,
  setFailMessage,
  setTimeout,
  setLoadingAfterTimeout
}) => {
  setLoading(true);

  (meetData.typeOfMeeting == "Upcoming" || meetData.typeOfMeeting == "Ongoing")
    ? setUpcomingFVModal(true)
    : setCIcancelMeetOpenView(true);

  const meeetingData = await GET(Url.GetMeetingMomByMeetingId.replace('{meetingId}', `${meetData?.mid}`).replace("{isAttendeeRequired}", "Y"), token);

  if (meeetingData.SUCCESS) {
    const { meetingSubject, mid, startDate, endDate, startTime, endTime, emailDetails, meetingAgenda,
      meetingLocation, message, cancelledByName, cancelReason } = meeetingData?.DATA;

    const data = extractMeetingData(meeetingData?.DATA);

    setFullView((prevState) => ({
      isClicked: false,
      viewMore: false,
      viewMoreAttendees: false,
      typeOfMeeting: meetData?.typeOfMeeting,
      data: data
    }));

    setLoading(true);
    setTimeout(() => {
      setLoading(false)
    }, 1100);
  }
  else if (meeetingData?.STATUS == 401) {
    setLoading(false);
    setSessionExpiredModal(true);
    setFailMessage("Session expired");
  }else if (meeetingData?.STATUS == 500) {
    setLoading(false);
    setSessionExpiredModal(true);
    setFailMessage("Session expired");
  }else if (meeetingData?.STATUS == 400) {
    setLoading(false);
    setSessionExpiredModal(true);
    setFailMessage("Session expired");
  }else if (meeetingData?.STATUS == 403) {
    setLoading(false);
    setSessionExpiredModal(true);
    setFailMessage("Session expired");
  }else if (meeetingData?.STATUS == 404) {
    setLoading(false);
    setSessionExpiredModal(true);
    setFailMessage("Session expired");
  }
}

export const handleDeleteMeeting = async ({
  meetingToDelete,
  Url,
  DELETE,
  token,
  setOpenDeleteModal,
  setLoading,
  setSuccessMessage,
  setOpenSuccessModal,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal
}) => {
  setOpenDeleteModal(false);
  let url;

  if (meetingToDelete.type === "Cancelled" || meetingToDelete.type === "Past") {
    url = Url.deleteMeeting.replace("{mid}", `${meetingToDelete.id}`);
  } else {
    url = Url.cancelUpcomingMeeting.replace("{mid}", `${meetingToDelete.id}`);
  }

  try {
    setLoading(true);
    const cancelMeetingResp = await DELETE(url, token);

    if (cancelMeetingResp.SUCCESS) {
      setLoading(false);
      setSuccessMessage('Meeting Deleted Successfully.');
      setOpenSuccessModal(true);
    } else if (cancelMeetingResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelMeetingResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelMeetingResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelMeetingResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelMeetingResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage('Failed to delete meeting');
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage('Failed to delete meeting');
    setOpenFailModal(true);
  }
};

export const handleCancel = async ({
  idToCancelMeeting,
  reason,
  setReason,
  setLoading,
  setOpenCancelModal,
  setSuccessMessage,
  setOpenSuccessModal,
  setFailMessage,
  setOpenFailModal,
  setSessionExpiredModal,
  token
}) => {
  setReason("");
  try {
    setOpenCancelModal(false);
    setLoading(true);

    const body = {
      cancelReason: reason
    };

    const cancelMeetingResp = await PUT(Url.cancelUpcomingMeeting.replace("{mid}", `${idToCancelMeeting}`), token, body);

    if (cancelMeetingResp.SUCCESS) {
      setLoading(false);
      setSuccessMessage('Meeting cancelled successfully.');
      setOpenSuccessModal(true);
    } else if (cancelMeetingResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed to cancel meeting.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setOpenCancelModal(false);
    setOpenFailModal(true);
    setFailMessage("Failed to cancel meeting.");
  }
};


export function getStartAndEndDateOfWeek(givenDate) {
  const date = new Date(givenDate);

  const dayOfWeek = date.getDay();

  const startDate = new Date(date);
  startDate.setDate(date.getDate() - dayOfWeek);

  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);

  const startMonth = startDate.toLocaleString('en-US', { month: 'long' });
  const endMonth = endDate.toLocaleString('en-US', { month: 'long' });

  let formattedStartDate = startDate.getDate().toString();
  let formattedEndDate = endDate.getDate().toString();

  if (formattedStartDate.length === 1) {
    formattedStartDate = '0' + formattedStartDate;
  }
  if (formattedEndDate.length === 1) {
    formattedEndDate = '0' + formattedEndDate;
  }

  if (startMonth === endMonth) {
    return `${startMonth} ${formattedStartDate} - ${formattedEndDate}, ${endDate.getFullYear()}`;
  } else {
    return `${startMonth} ${formattedStartDate} - ${endMonth} ${formattedEndDate}, ${endDate.getFullYear()}`;
  }
}

export const calculateDivHeights = (setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight) => {
  const div = document.getElementById("agenda_div");
  const res = isOverflowingCalInt(div);

  const div2 = document.getElementById("message_div");
  const res2 = isOverflowingCalInt(div2);

  const div3 = document.getElementById("attendees_div");
  const res3 = isOverflowingCalInt(div3);

  if (res3) {
    setAttendeesDivHeight(res3);
  }

  if (res) {
    setAgendaDivHeight(res);
  }

  if (res2) {
    setMsgDivHeight(res2);
  }
};

export const extractDates = (columns, view) => {
  let dateArr = [];
  [...columns]?.map((item, index) => {
    if (view === "week" && index >= [...columns]?.length - 3) {
      const dateStr = `${item?.innerHTML}`.split(" ");
      if (dateStr[0] < 10) {
        dateStr[0] = `0${dateStr[0]}`;
      }
      dateArr.push(dateStr[0]);
    } else if (view === "month" && index <= 1) {
      dateArr.push(item?.innerHTML);
    }
    return item;
  });
  return dateArr;
};

export const handleMeetingClick = ({
  event,
  handleOpenFullView,
  navigateToMeeting,
  setViewPastMeeting,
  setFromPastMeeting,
  navigate,
  AccRoles,
  GET,
  Url,
  token,
  setLoading,
  setUpcomingFVModal,
  setCIcancelMeetOpenView,
  setFullView,
  extractMeetingData,
  setSessionExpiredModal,
  setFailMessage,
  setTimeoutFn,
}) => {
  if (event?.typeOfMeeting === "Upcoming" || event?.typeOfMeeting === "Ongoing" || event?.typeOfMeeting === "Cancelled") {
    handleOpenFullView({
      meetData: event,
      GET,
      Url,
      token,
      setLoading,
      setUpcomingFVModal,
      setCIcancelMeetOpenView,
      setFullView,
      extractMeetingData,
      setSessionExpiredModal,
      setFailMessage,
      setTimeout: setTimeoutFn,
      setLoadingAfterTimeout: setLoading,
    });
  } else if (event?.typeOfMeeting === "Past" && event?.hasMOM === "view") {
    navigateToMeeting(event, setViewPastMeeting, setFromPastMeeting, navigate, AccRoles);
  } else {
    console.log("condition failed");
  }
};


export const handleMeetingClickForEdit = ({
  event,
  usermail,
  allEmailIdArr,
  pastAcc,
  from,
  rbac,
  navigate,
  handleNavigateForEditMeeting,
}) => {
  const isPastMeetingWithAccess =
    event?.typeOfMeeting === "Past" &&
    allEmailIdArr.includes(usermail) &&
    pastAcc?.editAccess === "Y";

  const isEditableMeeting =
    (event?.typeOfMeeting === "Cancelled" ||
      event.typeOfMeeting === "Upcoming" ||
      event.typeOfMeeting === "Ongoing") &&
    from[0]?.participantEmail === usermail &&
    rbac?.editAccess === "Y";

  if ((isPastMeetingWithAccess || isEditableMeeting) && pastAcc?.editAccess !== "N") {
    handleNavigateForEditMeeting(event, navigate);
  }
};


export const handleMeetingAction = ({
  event,
  usermail,
  from,
  rbac,
  GeneratePDF,
  setFailMessage,
  setOpenDeleteModal,
  setMeetingToDelete,
  setOpenCancelModal,
  setIdToCancelMeeting,
  setCancelMeetingName,
  downloadIcs,
}) => {
  if (event?.typeOfMeeting === "Past" && event?.hasMOM !== "N/A") {
    GeneratePDF(event?.mid, event?.momVersion);
  } else if (event?.typeOfMeeting === "Cancelled") {
    if (from[0]?.participantEmail === usermail && rbac?.editAccess === "Y") {
      setFailMessage("Are you sure you want to delete this meeting?");
      setOpenDeleteModal(true);
      setMeetingToDelete({ id: event?.mid, type: event?.typeOfMeeting });
    }
  } else if (event?.typeOfMeeting === "Upcoming") {
    if (from[0]?.participantEmail === usermail && rbac?.editAccess !== "N") {
      setFailMessage("Are you sure you want to cancel this meeting?");
      setOpenCancelModal(true);
      setIdToCancelMeeting(event?.mid);
      setCancelMeetingName(event?.meetingSubject);
    }
  } else if (event?.typeOfMeeting === "Ongoing") {
    downloadIcs(event?.mid, event?.meetingSubject);
  }
};


export const handleEditMeetingAction = ({
  event,
  usermail,
  allEmailIdArr,
  pastAcc,
  from,
  navigate,
  handleNavigateForEditMeeting
}) => {
  if (
    ((event?.typeOfMeeting === "Past" && allEmailIdArr.includes(usermail) && pastAcc?.editAccess === "Y") ||
      ((event?.typeOfMeeting === "Cancelled" || event?.typeOfMeeting === "Upcoming" || event?.typeOfMeeting === "Ongoing") &&
        (from[0]?.participantEmail === usermail) && pastAcc?.editAccess === "Y"))
  ) {
    if (pastAcc?.editAccess !== "N") {
      handleNavigateForEditMeeting(event, navigate);
    }
  }
};


export const handleMeetingEvent = ({
  event,
  usermail,
  from,
  rbac,
  setFailMessage,
  setOpenDeleteModal,
  setMeetingToDelete,
  setOpenCancelModal,
  setIdToCancelMeeting,
  setCancelMeetingName,
  GeneratePDF,
  downloadIcs
}) => {
  if (event?.typeOfMeeting === "Past" && event?.hasMOM !== "N/A") {
    GeneratePDF(event?.mid, event?.momVersion);
  } else if (event?.typeOfMeeting === "Cancelled") {
    if (from[0]?.participantEmail === usermail && rbac.deleteAccess !== "N") {
      setFailMessage("Are you sure you want to delete this meeting?");
      setOpenDeleteModal(true);
      setMeetingToDelete({ id: event?.mid, type: event?.typeOfMeeting });
    }
  } else if (event?.typeOfMeeting === "Upcoming") {
    if (from[0]?.participantEmail === usermail && rbac?.editAccess !== "N") {
      setFailMessage('Are you sure you want to cancel this meeting?');
      setOpenCancelModal(true);
      setIdToCancelMeeting(event?.mid);
      setCancelMeetingName(event?.meetingSubject);
    }
  } else if (event?.typeOfMeeting === "Ongoing") {
    downloadIcs(event?.mid, event?.meetingSubject);
  }
};



const CalendarIntegration = () => {
  const username = Cuurent_USERNAME();

  const token = sessionStorage.getItem("TOKEN");

  const { setLoading, setViewPastMeeting, setActive, setFromPastMeeting } = useContext(contextData);
  const navigate = useNavigate();

  // -------------------------------------------------------------------Data States----------------------------------------------------------------------------------------
  const [datePickerDate, setDatePickerDate] = useState(new Date());
  const [searchInp, setSearchInp] = useState("");
  const [view, setView] = useState('month');
  const [monthStartDate, setMonthStartDate] = useState()
  const [monthEndDate, setMonthEndDate] = useState()
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false);

  const [lastTwoDates, setLastTwoDates] = useState([])
  const [highlitedDatesToShow, setHighlightedDatesToShow] = useState([]);

  const [eventData, setEventData] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState("");
  const [viewMore, setViewMore] = useState({
    isClicked: false,
    itemIndex: 0
  })

  const [fullView, setFullView] = useState({
    isClicked: false,
    viewMore: false,
    viewMoreMsg: false,
    typeOfMeeting: null,
    viewMoreAttendees: false,
    data: {
      agenda: []
    }
  })
  const useCase = "QMS Calendar Integration";
  const rbac = useRBAC(useCase);
  const access = Cuurent_USER_ROLES();

  // const AccRoles = access.split(",")
  const AccRoles = access;



  // -------------------------------------------------------------------Boolean States-------------------------------------------------------------------------------------
  const [openFromDatePicker, setOpenFromDatePicker] = useState(true);


  // -------------------------------------------------------------------Popup States-------------------------------------------------------------------------------------
  const [failMessage, setFailMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [idToCancelMeeting, setIdToCancelMeeting] = useState();
  const [cancelMeetingName, setCancelMeetingName] = useState("");
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [reason, setReason] = useState("")
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [meetingToDelete, setMeetingToDelete] = useState({
    id: "",
    type: ""
  })
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [pos, setPos] = useState(false);
  const [UpcomingFVModal, setUpcomingFVModal] = useState(false);
  const [CIcancelMeetOpenView, setCIcancelMeetOpenView] = useState(false)

  const [rightCoordinates, setRightCoordinates] = useState({ x: 0, y: 0 });

  const [agendaDivHeight, setAgendaDivHeight] = useState(false);
  const [msgDivHeight, setMsgDivHeight] = useState(false);
  const [attendeesDivHeight, setAttendeesDivHeight] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      calculateDivHeights(setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight);
    }, 1000);
  }, [fullView]);

  let rrbac = Cuurent_RBAC_roles();
  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = sessionStorage.getItem("USER")

  const [pastAcc, setPastAcc] = useState({})

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Past Meetings");
      if (roleWithQMSDashboard) {
        setPastAcc(roleWithQMSDashboard);
      }
    }
  }, []);

  // -------------------------------------------------------------------Global Variables-----------------------------------------------------------------------------------
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const localizer = momentLocalizer(moment);

  const handleMonthChange = (newDate) => {

    setDatePickerDate(newDate)
  };
  const [randomNumber, setRandomNumber] = useState(0);

  // Function to generate and set a random number
  const generateRandomNumber = () => {
    setRandomNumber(randomNumber + 1);
  };


  useEffect(() => {
    const currentDate = moment();
    const month = currentDate.month();
    const year = currentDate.year();
    const startDate = moment({ year, month }).startOf('month');
    const endDate = moment({ year, month }).endOf('month');
    setMonthStartDate(startDate.format('YYYY-MM-DD'))
    setMonthEndDate(endDate.format('YYYY-MM-DD'))


  }, [])


  useEffect(() => {
    const month = datePickerDate?.getMonth();
    const year = datePickerDate?.getFullYear();
    const startDate = moment({ year, month }).startOf('month');
    const endDate = moment({ year, month }).endOf('month');
    setMonthStartDate(startDate.format('YYYY-MM-DD'));
    setMonthEndDate(endDate.format('YYYY-MM-DD'));
    generateRandomNumber();

    generateHighlightedDates(datePickerDate, view, setHighlightedDatesToShow);
  }, [datePickerDate]);

  useEffect(() => {
    generateHighlightedDates(datePickerDate, view, setHighlightedDatesToShow);
  }, [view]);


  useEffect(() => {
    getCalendarDataByView({
      POST,
      Url,
      token,
      monthStartDate,
      monthEndDate,
      setLoading,
      setEventData,
      setFailMessage,
    });
  }, [view, randomNumber]);

  //==================================================react select ==============================================================
  let options = [
    {
      label: "Month",
      value: "month",
    },
    {
      label: "Day",
      value: "day",
    },
    {
      label: "Week",
      value: "week",
    }

  ];

  const customStylesSelect = {
    option: (provided, state) => ({
      ...provided,
      color: "black",
      backgroundColor: state.isSelected ? "#00ADEE" : "white",
      padding: 10,
      zIndex: 9999,
      height: 20,
      display: "flex",
      alignItems: "center",
      fontSize: 13,
      cursor: "pointer",
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "100%",
      innerHeight: "22px",
      padding: 0,
      position: "absolute",
      zIndex: 9999,
      display: "block",
      top: 22,
      cursor: "pointer",
    }),
    control: (provided, state) => ({
      border: "1px solid gray",
      borderRadius: 5,
      height: 25,
      width: 95,
      fontSize: 13,
      display: "flex",
      cursor: "pointer",
      backgroundColor: 'white',
      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
    }),
    indicatorSeparator: () => ({
      display: 'none' // Hide the indicator separator
    }),
  };
  const [calType, setCalType] = useState({
    label: "Month",
    value: "month",
  });

  //====================================================== react select =====================================================================

  // ---------------------------------------------------------------------------------------Handle Full View Functionallity-------------------------------------------------------------------------

  // --------------------------------------------------------------------------------------------------------Navigate For Edit Meeting---------------------------------------------------------------

  let usermail = Cuurent_EMAIL();
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  // -----------------------------------------------------------------------Handle Delete Functionallity---------------------------------------------------------------


  // -----------------------------------------------------------------------Handle Cancel Functionallity---------------------------------------------------------------



  // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  useEffect(() => {
    const updateRightCoordinates = () => {
      // Get the width of the viewport
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      // Calculate the coordinates of the right side of the screen
      const x = viewportWidth;
      const y = 0; // You can adjust this if you want a specific y-coordinate

      setRightCoordinates({ x, y });
    };

    // Attach the event listener for resizing (in case the viewport size changes)
    window.addEventListener('resize', updateRightCoordinates);

    // Initial update
    updateRightCoordinates();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateRightCoordinates);
    };
  }, []);

  


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const columns = view === "week"
        ? document.getElementsByClassName("custom-day-in-week-view")
        : document.getElementsByClassName("custom-day-in-day-view");

      const dateArr = extractDates(columns, view);
      setLastTwoDates(dateArr);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [view, datePickerDate, openFromDatePicker]);


  // ---------------------------------------------------------------------------------------Event Typewise Calendar Tooltoip JSx----------------------------------------------------------------------
  const CustomEvent = ({ event }) => {
    let eventContent;

    const eventBorderLeft = event?.deptartmentTagMaster?.deptTag === "Facility" ?
      "4px solid orange" :
      event?.deptartmentTagMaster?.deptTag === "IT" ?
        "4px solid rgb(76, 184, 124)" :
        event?.deptartmentTagMaster?.deptTag === "HR" ?
          "4px solid rgb(112, 0, 152)" :
          "4px solid rgb(5, 125, 170)"

    const eventBackgroundColor = event?.deptartmentTagMaster?.deptTag === "Facility" ?
      "#FFF2C6B0" :
      event?.deptartmentTagMaster?.deptTag === "IT" ?
        "#D2FFEA" :
        event?.deptartmentTagMaster?.deptTag === "HR" ?
          "#F6E6FC" :
          "#D9EDF6"

    const viewMoreDummy = event?.meetingAgenda ? event?.meetingAgenda?.split("\n") : [];
    const agendaCal = event?.meetingAgenda;

    const sanitizedAgendaCal = DOMPurify.sanitize(agendaCal);


    var AttendeesList = '';
    event?.participantsList?.map((i, index) => {
      let lastitem = index + 1 == event?.participantsList?.length ? "" : ", ";

      AttendeesList += i.fullName + lastitem;
    })
    const parseStartDate = event?.parseStartDate.split("-");
    const dateToCompare = parseStartDate[0];

    const parseDateDay = new Date(event?.start);
    var specificDate = moment(parseDateDay); // Replace '2024-01-11' with your desired date

    // Format the day in three letters (e.g., Sun, Mon)
    var dayCompare = specificDate.format('dddd').toUpperCase();


    const { to, from, optional } = getEmailClassification(event.emailDetail);
    const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(event.participantsList);


    switch (view) {
      case 'month':
        eventContent = (
          <div className="toolbar-container month-toolbar-wraper-main">

            <p style={{ margin: 0 }}>{event.count} Meetings</p>

            <div className={`month-tooltip-wraper`}>
              <div className="month-tooltip-triangle"></div>
            </div>

            <div className={`event-tooltip ${((dayCompare == lastTwoDates[0] || dayCompare == lastTwoDates[1]) && 'tooltip-month-wraper-after-open')}`} >
              {
                event?.calendarIntegrationDTO?.map((i, index) => {

                  const { to, from, optional } = getEmailClassification(i.emailDetail);
                  const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(i.participantsList);

                  return (
                    <div className='tooltip-month-item' style={
                      i?.deptartmentTagMaster?.deptTag == "HR"
                        ? {
                          borderLeft: "4px solid #700098",
                        }
                        : i?.deptartmentTagMaster?.deptTag == "IT"
                          ? {
                            borderLeft: "4px solid #4CB87C",
                          }
                          : i?.deptartmentTagMaster?.deptTag == "Governance"
                            ? {
                              borderLeft: "4px solid #057DAA",
                            }
                            : {
                              borderLeft: "4px solid #FF9B00",
                            }
                    }

                      onClick={() => (i?.typeOfMeeting == "Upcoming" || i?.typeOfMeeting == "Ongoing" || i?.typeOfMeeting == "Cancelled") ? handleOpenFullView({
                        meetData: i,
                        GET,
                        Url,
                        token,
                        setLoading,
                        setUpcomingFVModal,
                        setCIcancelMeetOpenView,
                        setFullView,
                        extractMeetingData,
                        setSessionExpiredModal,
                        setFailMessage,
                        setTimeout: setTimeout, // You can directly use setTimeout
                        setLoadingAfterTimeout: setLoading,
                      }) : ((
                        ((i.typeOfMeeting == 'Past') && ((allEmailIdArr.includes(usermail)) && rbac?.editAccess === "Y"))
                      ) && navigateToMeeting(i, setViewPastMeeting, setFromPastMeeting, navigate, AccRoles))
                      }
                    >

                      <div className='cal-integration-single-card-cont'>
                        <div className='cal-integration-meeting-subject-cont' style={{ color: i?.deptartmentTagMaster?.deptTag == "HR" ? "#700098" : i?.deptartmentTagMaster?.deptTag == "IT" ? "#4CB87C" : i?.deptartmentTagMaster?.deptTag == "Governance" ? "#057DAA" : "#FF9B00" }}>
                          {i?.meetingSubject}
                        </div>
                        <div className='cal-integration-meeting-time-status-cont'>
                          <div style={{ width: "60%", textAlign: "left" }}><span style={{ fontWeight: "bold" }}>Time :</span> {i.startTime} - { }{i.endTime === "11:59 PM" ? "12:00 AM" : i.endTime}</div>

                          <div style={{ width: "40%", textAlign: "left", }}>{i?.typeOfMeeting == "Past" ? <span><span style={{ fontWeight: "bold" }}>Duration :</span> {i?.duration}</span> : <span><span style={{ fontWeight: "bold" }}>Status :</span> <span style={{ color: i?.typeOfMeeting == "Cancelled" && "red" }}>{i?.typeOfMeeting}</span></span>}</div>
                        </div>
                      </div>
                      <div className='cal-integration-single-card-cont'>
                        <div className='cal-integration-meeting-tag-cont' style={{ color: i?.deptartmentTagMaster?.deptTag == "HR" ? "#700098" : i?.deptartmentTagMaster?.deptTag == "IT" ? "#4CB87C" : i?.deptartmentTagMaster?.deptTag == "Governance" ? "#057DAA" : "#FF9B00" }}>{i?.deptartmentTagMaster?.deptTag}</div>
                        <div className='cal-integration-meeting-mom-cont'>
                          {i?.typeOfMeeting == "Past" ? <div>
                            <span style={{ fontWeight: 600 }}> MOM :</span> {i?.hasMOM == "N/A" ? "N/A" : " View"}
                          </div>
                            : i?.typeOfMeeting == "Ongoing" ?
                              <button className='cal-integration-join-btn'>JOIN</button>
                              :
                              <></>
                          }
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div >
        );
        break;
      case 'week':
        eventContent = (
          <div className='week-event-container week-main-div-cont' style={{ borderLeft: eventBorderLeft, backgroundColor: eventBackgroundColor }}>
            <span
              id={"normal-text"}
              className='cal-integration-normal-text'
            >
              &nbsp;{event?.meetingSubject}
            </span>


            <div className={`tooltip-week-wraper ${(openFromDatePicker && (dateToCompare == lastTwoDates[0] || dateToCompare == lastTwoDates[1] || dateToCompare == lastTwoDates[2]) && 'tooltip-week-wraper-after-open')}`} style={{ borderLeft: eventBorderLeft, display: (viewMore?.isClicked && viewMore?.itemIndex == event?.mid) ? "block" : "", minHeight: "124px", padding: "10px", top: isTimeBefore2AM(event?.startTime) && "50%", bottom: !isTimeBefore2AM(event?.startTime) && "50%", left: (dateToCompare == lastTwoDates[0] || dateToCompare == lastTwoDates[1] || dateToCompare == lastTwoDates[2]) ? "-310px" : "0px", }}>
              <div className="week-tooltip-container" >
                <div className="side-buttons">

                  <button
                    id={event?.hasMOM == "N/A" && event?.typeOfMeeting == "Past" ? "disabled" : "normal"}
                    data-testid='OpenView'
                    onClick={() =>
                      handleMeetingClick({
                        event,
                        handleOpenFullView,
                        navigateToMeeting,
                        setViewPastMeeting,
                        setFromPastMeeting,
                        navigate,
                        AccRoles,
                        GET,
                        Url,
                        token,
                        setLoading,
                        setUpcomingFVModal,
                        setCIcancelMeetOpenView,
                        setFullView,
                        extractMeetingData,
                        setSessionExpiredModal,
                        setFailMessage,
                        setTimeoutFn: setTimeout,
                      })
                    }

                  >
                    <BsEye fill="#00ADEE" size={"16px"} />
                  </button>

                  <button


                    id={
                      (((event?.typeOfMeeting == "Past") && ((allEmailIdArr.includes(usermail)) && pastAcc?.editAccess === "Y")) || ((event?.typeOfMeeting == "Cancelled" || event.typeOfMeeting == "Upcoming" || event.typeOfMeeting == "Ongoing") && (from[0]?.participantEmail == usermail) && pastAcc?.editAccess === "Y")) ? "normal" : "disabled"
                    }



                    onClick={() =>
                      handleMeetingClickForEdit({
                        event,
                        usermail,
                        allEmailIdArr,
                        pastAcc,
                        from,
                        rbac,
                        navigate,
                        handleNavigateForEditMeeting,
                      })
                    }

                  >

                    {event?.typeOfMeeting == "Cancelled" ? <MdSchedule fill="#00ADEE" size={"15px"} /> :
                      <SlPencil fill="#00ADEE" size={"15px"} />}
                  </button>

                  <button


                    id={((event?.typeOfMeeting == "Past" && event?.hasMOM !== "N/A") || (((event.typeOfMeeting == "Cancelled" || event.typeOfMeeting == "Upcoming") && (from[0]?.participantEmail == usermail)) && rbac?.editAccess == "Y") || (event?.typeOfMeeting == "Ongoing")) ? "normal" : "disabled"}



                    onClick={() =>
                      handleMeetingAction({
                        event,
                        usermail,
                        from,
                        rbac,
                        GeneratePDF,
                        setFailMessage,
                        setOpenDeleteModal,
                        setMeetingToDelete,
                        setOpenCancelModal,
                        setIdToCancelMeeting,
                        setCancelMeetingName,
                        downloadIcs,
                      })
                    }

                  >


                    {
                      event?.typeOfMeeting == "Upcoming" ?
                        <AiOutlineClose fill="#00ADEE" size={"15px"} /> :
                        event?.typeOfMeeting == "Cancelled" ? <AiOutlineDelete fill="#00ADEE" size={"15px"} /> :
                          <BsDownload fill="#00ADEE" size={"15px"} />
                    }
                  </button>

                </div>

                <p className="heading" style={{ textDecoration: event?.typeOfMeeting == "Cancelled" ? "line-through" : "none" }}>{event?.meetingSubject}</p>

                <div className="inner-field">
                  <div className="left-label">
                    <span>Date & Time</span><span>:</span>
                  </div>
                  <div style={{ paddingLeft: "5px" }} className="right-data">
                    <p>{event?.parseStartDate}&nbsp;&nbsp;&nbsp;{event?.startTime}-{event?.endTime === "11:59 PM" ? "12:00 AM" : event?.endTime}</p>
                  </div>
                </div>

                <div className="inner-field">
                  <div className="left-label">
                    <span>Attendees</span><span>:</span>
                  </div>
                  <div style={{ paddingLeft: "7px" }} className="right-data ele">
                    <p>{

                      AttendeesList

                    }</p>
                  </div>
                </div>

                <div className="inner-field" style={{}}>
                  <div className="left-label">
                    <span>Agenda</span><span>:</span>
                  </div>

                  <div style={{ paddingLeft: "5px", textAlign: "left" }} className="right-data ele">

                    {
                      !(event?.meetingAgenda?.trim().length === 0 || event?.meeetingData?.agenda.length === 0) ? (
                        <div className='ellipsisData_cal'>
                          {firstLineTextFromHtml(event?.meetingAgenda)}
                        </div>
                      ) : (
                        "Not Available"
                      )
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        );
        break;
      case 'day':
        eventContent = (
          <div className='day-event-container week-main-div-cont'
          onMouseEnter={(event) => mouseEnter(event, setPos)}
            style={{
              borderLeft: eventBorderLeft,
              backgroundColor: eventBackgroundColor,
            }}>
            <span
              id={"normal-text"}
              className='cal-integration-normal-text'
            >
              &nbsp;{event?.meetingSubject}
            </span>

            <div className="tooltip-day-wraper"
              style={{ borderLeft: eventBorderLeft, display: (viewMore?.isClicked && viewMore?.itemIndex == event?.mid) ? "block" : "", minHeight: "124px", padding: "8px 10px 10px 10px", top: isTimeBefore2AM(event?.startTime) && "50%", bottom: !isTimeBefore2AM(event?.startTime) && "50%", right: pos && "10%", left: !pos && "10%" }}>
              <div className="day-tooltip-container"  >

                <div className="side-buttons">

                  <button

                    id={event?.hasMOM == "N/A" && event?.typeOfMeeting == "Past" ? "disabled" : "normal"}
                    onClick={() => (event?.typeOfMeeting == "Upcoming" || event?.typeOfMeeting == "Ongoing" || event?.typeOfMeeting == "Cancelled") ? handleOpenFullView({
                      meetData:  event,
                      GET,
                      Url,
                      token,
                      setLoading,
                      setUpcomingFVModal,
                      setCIcancelMeetOpenView,
                      setFullView,
                      extractMeetingData,
                      setSessionExpiredModal,
                      setFailMessage,
                       setTimeout,
                       setLoadingAfterTimeout:setLoading,
                    }) : ((event?.typeOfMeeting == "Past" && event?.hasMOM == "view") && navigateToMeeting(event, setViewPastMeeting, setFromPastMeeting, navigate, AccRoles))}>
                    <BsEye fill="#00ADEE" size={"15px"} />
                  </button>

                  <button



                    id={
                      (((event?.typeOfMeeting == "Past") && ((allEmailIdArr.includes(usermail)) && pastAcc?.editAccess === "Y")) || ((event?.typeOfMeeting == "Cancelled" || event.typeOfMeeting == "Upcoming" || event.typeOfMeeting == "Ongoing") && (from[0]?.participantEmail == usermail) && pastAcc?.editAccess === "Y")) ? "normal" : "disabled"
                    }



                    onClick={() => {
                      handleEditMeetingAction({
                        event,
                        usermail,
                        allEmailIdArr,
                        pastAcc,
                        from,
                        navigate,
                        handleNavigateForEditMeeting
                      });
                    }}
                  >
                    {event?.typeOfMeeting == "Cancelled" ? <MdSchedule fill="#00ADEE" size={"15px"} /> :
                      <SlPencil fill="#00ADEE" size={"15px"} />}
                  </button>
                  <button
                    id={((event?.typeOfMeeting == "Past" && event?.hasMOM !== "N/A") || (((event.typeOfMeeting == "Cancelled" || event.typeOfMeeting == "Upcoming") && (from[0]?.participantEmail == usermail)) && rbac?.editAccess == "Y") || (event?.typeOfMeeting == "Ongoing")) ? "normal" : "disabled"}



                    onClick={() => {
                      handleMeetingEvent({
                        event,
                        usermail,
                        from,
                        rbac,
                        setFailMessage,
                        setOpenDeleteModal,
                        setMeetingToDelete,
                        setOpenCancelModal,
                        setIdToCancelMeeting,
                        setCancelMeetingName,
                        GeneratePDF,
                        downloadIcs
                      });
                    }}

                  >
                    {
                      event?.typeOfMeeting == "Upcoming" ?
                        <AiOutlineClose fill="#00ADEE" size={"15px"} /> :
                        event?.typeOfMeeting == "Cancelled" ? <AiOutlineDelete fill="#00ADEE" size={"15px"} /> :
                          <BsDownload fill="#00ADEE" size={"15px"} />
                    }
                  </button>
                </div>

                <p className="heading" style={{ textDecoration: event?.typeOfMeeting == "Cancelled" ? "line-through" : "none", lineHeight: "17.5px" }} sid>{event?.meetingSubject}</p>

                <div className="inner-field">
                  <div className="left-label">
                    <span>Date & Time</span><span>:</span>
                  </div>
                  <div style={{ paddingLeft: "5px" }} className="right-data">
                    <p>{event?.parseStartDate}&nbsp;&nbsp;&nbsp;{event?.startTime}-{event?.endTime === "11:59 PM" ? "12:00 AM" : event?.endTime}</p>
                  </div>
                </div>

                <div className="inner-field">
                  <div className="left-label">
                    <span>Attendees</span><span>:</span>
                  </div>
                  <div style={{ paddingLeft: "7px" }} className="right-data ele">
                    <p>{

                      AttendeesList
                    }</p>
                  </div>
                </div>

                <div className="inner-field">
                  <div className="left-label">

                    <span>Agenda</span><span>:</span>
                  </div>
                  <div className="right-data ele">
                    <div style={{ paddingLeft: "5px", textAlign: "left" }} className="right-data ele">
                      {!(stripHtmlTags(event?.meetingAgenda || '').trim().length === 0 || event?.meetingAgenda?.agenda?.length === 0) ?
                        <div className='ellipsisData_cal' dangerouslySetInnerHTML={{ __html: firstLineTextFromHtml(sanitizedAgendaCal) }} /> :
                        "Not Available"
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        );
        break;
      default:
        eventContent = (
          <div>
          </div>
        );
    }

    return eventContent;
  };

  const renderHeader = ({ date }) => {
    if (view == "week") {
      // Render CustomWeekHeader for week view
      return <CustomWeekHeader date={date} />;
    } else if (view == "month") {
      return <CustomMonthHeader date={date} />;
      // Render CustomMonthHeader for other views
    } else {
      return <CustomHeaderDay date={date} />;
      // Render CustomMonthHeader for other views
    }

  };



 



  const FullViewMeeeting = () => {
    setUpcomingFVModal(true)
  }
  const handleEventMouseOver = (e) => [

  ]

  return (
    <div className='calendar-integration-main-container'>
      <div className="select-period-container">
        <div className='select-month-date-cont'>
          <div className="month-selector-container">
            <label htmlFor="calendarType">Select Calendar Type : </label>

            <Select
              isSearchable={false}
              options={options}
              styles={customStylesSelect}
              value={calType}
              onChange={(e) => {

                setCalType(e);
                setCurrentView(e.value, setView)

              }}
            />
          </div>

          <div className="center-container">
            <div className="top-date-container" style={{ gap: "5px" }}>
              <span style={{ marginRight: "5px", display: "flex", cursor: "pointer" }} data-testid="setOpenFromDatePicker" onClick={() => setOpenFromDatePicker(!openFromDatePicker)}>
                <svg id="calendar-line-icon" xmlns="http://www.w3.org/2000/svg" width="19.119px" height="24.122px" viewBox="0 0 27.119 27.122">
                  <path
                    id="Path_15922"
                    data-name="Path 15922"
                    d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                    fill="#00aff1"
                  />
                </svg>
              </span>
              <button data-testid="moveToPrevMonth1" className={`change-month-btn ${selectedDiv === "div1" ? "selected-month-btn" : " "}`} onClick={() => {
                setSelectedDiv("div1");
                moveToPrevMonth(view, datePickerDate, setDatePickerDate)
              }}>
                <IoCaretBack fill={"#AFAFAF"} />
              </button>
              <button data-testid="moveToPrevMonth2" className={`change-month-btn ${selectedDiv === "div2" ? "selected-month-btn" : " "}`} onClick={() => {
                setSelectedDiv("div2");
                moveToNextMonth({ view, datePickerDate, setDatePickerDate });
              }}>
                <IoCaretForward fill={"#AFAFAF"} />
              </button>
              <h4 style={{ marginLeft: "5px" }}>
                {view === "week" ? getStartAndEndDateOfWeek(datePickerDate) :
                  view === "day" ? moment(datePickerDate).format('MMMM DD, YYYY') :
                    `${monthNames[datePickerDate?.getMonth()]} ${datePickerDate.getFullYear()}`}
              </h4>
            </div>
          </div>
        </div>

        <div className="search-container">





          {
            AccRoles?.includes("QMS Organizer") &&
            (
              <button className="create-meeting-btn" type="" onClick={() => goToSetupMeeting(access, navigate, setActive)}>
                + Setup New Meeting
              </button>

            )
          }




        </div>
      </div>
      {
        fullView?.isClicked ?
          <FullViewMeeeting />
          :
          <div className="calendar-container-main">
            <div className="open-cal-btn" onClick={() => setOpenFromDatePicker(!openFromDatePicker)}>
              {openFromDatePicker ? <FaAngleLeft fill={"#AFAFAF"} size={"18px"} style={{ padding: '2px 2px 2px 6px' }} /> : <FaAngleRight fill={"#AFAFAF"} size={"18px"} style={{ padding: '2px 2px 2px 6px' }} />}
            </div>
            <div className="calendar-date-picker" style={{ width: openFromDatePicker ? "24%" : "0%", opacity: openFromDatePicker ? 1 : 0 }}>
              <DatePicker
              data-testid="handleMonthChange-DatePicker"
                name="recEndDate"
                key={datePickerDate}
                style={{ color: "#B8B8B8", marginRight: openFromDatePicker ? "30px" : "0px", zIndex: 10 }}
                open={openFromDatePicker}
                showTimeSelect={false}
                selected={datePickerDate}
                value={datePickerDate}
                onChange={(date) => {
                  const selectedTimestamp = datePickerDate && datePickerDate.getTime();
                  const dateTimestamp = date && date.getTime();
                  if (selectedTimestamp !== dateTimestamp) {
                    handleSetDatePickerDate(date, setDatePickerDate);
                  }
                }}
                highlightDates={highlitedDatesToShow}
                onMonthChange={handleMonthChange}
              />

            </div>


            <div className="calendar-container-sub third-tab-cal" style={{ width: openFromDatePicker ? "93%" : "100%", }}>
              <Calendar
                className={view == "day" ? 'day-view-main' : view == "week" ? 'week-view-main' : ""}
                toolbar={false}
                localizer={localizer}
                formats={{ timeGutterFormat: customTimeFormat }}
                events={eventData}
                startAccessor="start"
                endAccessor="end"
                style={{ height: "100%" }}
                views={['day', 'week', 'month']}
                view={view}
                components={{
                  event: CustomEvent,
                  header: renderHeader
                }}
                date={datePickerDate}
                onMouseOver={handleEventMouseOver}
              />
            </div>

          </div>
      }

      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={() => getCalendarDataByView({
          POST,
          Url,
          token,
          monthStartDate,
          monthEndDate,
          setLoading,
          setEventData,
          setFailMessage,
        })}
      />


      <FailModal
        openFailModal={openDeleteModal}
        setOpenFailModal={setOpenDeleteModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() =>
          handleDeleteMeeting({
            meetingToDelete,
            Url,
            DELETE,
            token,
            setOpenDeleteModal,
            setLoading,
            setSuccessMessage,
            setOpenSuccessModal,
            setSessionExpiredModal,
            setFailMessage,
            setOpenFailModal
          })
        }
        recallFunctiononClose={() => handleCloseDeleteModel(setOpenDeleteModal)}
      />

      <CancelReason
        openReasonModal={openCancelModal}
        setOpenReasonModal={setOpenCancelModal}
        reasonState={reason}
        setReasonState={setReason}
        reasonChangeFunction={reasonChange}
        meetingName={cancelMeetingName}
        CancelledBy={username}
        recallFunctionOnOk={() =>
          handleCancel({
            idToCancelMeeting,
            reason,
            setReason,
            setLoading,
            setOpenCancelModal,
            setSuccessMessage,
            setOpenSuccessModal,
            setFailMessage,
            setOpenFailModal,
            setSessionExpiredModal,
            token
          })
          
        }
        recallFunctiononClose={() => handleCloseCancleModal(setOpenCancelModal)}
        setReason={setReason} 
      />

      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(navigate, setActive)}
        recallFunctiononClose={() => handleSessionExpClose(navigate, setActive)}
      />

      {/* ----------------------------------Month View Upcoming Meeting fullview Modal--------------------------------------- */}


      <UpcomingMeetingModal
        isOpen={UpcomingFVModal}
        onRequestClose={() => handleONRequestUPMFV(setUpcomingFVModal, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight)}
        customStyles={customStyles}
        fullView={fullView}
        setFullView={setFullView}
        setAgendaDivHeight={setAgendaDivHeight}
        setMsgDivHeight={setMsgDivHeight}
        setAttendeesDivHeight={setAttendeesDivHeight}
        attendeesDivHeight={attendeesDivHeight}
        agendaDivHeight={agendaDivHeight}
        msgDivHeight={msgDivHeight}
        stripHtmlTags={stripHtmlTags}
      />

      {/* ------------------------------------------------Month View Cancel meeting full view modal --------------------------------- */}


      <CancelledMeetingModal
        isOpen={CIcancelMeetOpenView}
        onRequestClose={() => handle_Close_Cancel_Modal(setCIcancelMeetOpenView, setAgendaDivHeight, setMsgDivHeight)}
        customStyles={customStyles}
        fullView={fullView}
        setFullView={setFullView}
        agendaDivHeight={agendaDivHeight}
        extractTextFromHtml={stripHtmlTags}
      />


    </div >
  )
}

export default CalendarIntegration